<script setup lang="ts">
import MAlert from '~/components/molecules/Alert.vue'
import { PopupType } from '~/static/enums/popup'

const { $listen, $off } = useNuxtApp()

const popupType = ref<PopupType | false>(false)
const popupText = ref('')

onMounted(() => {
  $listen('popup:show', showPopup)
})
onBeforeUnmount(() => {
  $off('popup:show', showPopup)
})

const showPopup = (payload: { type?: PopupType, text: string, closeAfter?: number }) => {
  popupType.value = payload.type ?? PopupType.Warning
  popupText.value = payload.text
  if (payload.closeAfter) {
    setTimeout(closePopup, payload.closeAfter * 1000)
  }
}

const closePopup = () => {
  popupType.value = false
}

</script>

<template>
  <div
    v-if="popupType"
    class="alert-wrap d-flex justify-content-center"
  >
    <MAlert
      class="justify-content-between w-fit-content"
      :type="popupType"
      @close="closePopup"
    >
      <template #text>
        <div class="me-2">
          {{ popupText }}
        </div>
      </template>
    </MAlert>
  </div>
</template>

<style lang="scss">
.alert-wrap {
  position: absolute;
  top: 70px;
  width: 100%;
  z-index: 100;

  .w-316 {
    width: 316px;
  }

  .w-fit-content {
    width: fit-content;
  }
}
</style>
